/** Format an amount in its source currency; never silently convert it to USD. */
export function channelMoney(amount: number, currency?: string | null): string {
  if (!currency || !/^[A-Z]{3}$/.test(currency)) {
    return `${amount.toLocaleString('en-US', { maximumFractionDigits: 2 })} (currency unavailable)`;
  }
  return new Intl.NumberFormat('en-US', { style: 'currency', currency, currencyDisplay: 'code' }).format(amount);
}
